/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import {
    DisplayHtmlContent,
    FormValidationAlert,
    FormValidationAlertErrors,
    Heading,
    Stack,
} from 'sarsaparilla';
import { getGatewayUrl } from 'shared-ui/utils/getGatewayUrl';
import type { TreePermitData, ParentLocation } from '../../../types/permit';

interface HeaderType {
    errors: FormValidationAlertErrors | null | undefined;
    parentLocation: Array<Partial<ParentLocation>>;
    treePermit: TreePermitData;
}
export default function Header({ errors, treePermit, parentLocation = [] }: HeaderType) {
    const location = [];
    const parentLocationSelected = parentLocation?.find(
        (item) => item.entity_id === treePermit?.parent_asset_id
    );
    if (!isNil(parentLocationSelected?.name)) {
        location.push(
            <span>
                <a href={getGatewayUrl(treePermit.parent_asset_id)}>
                    {parentLocationSelected?.name}
                </a>
            </span>
        );
    }

    if (!isNil(parentLocationSelected?.state_code)) {
        location.push(parentLocationSelected?.state_code);
    }

    const hasLocation = !!location.length;

    return (
        <div className="tp-header">
            <Stack space="xs">
                <Heading headingLevel={1} appearance="h3" className="tp-header-title">
                    Order Details
                </Heading>
                <Heading headingLevel={2} appearance="h6" className="tp-header-subtitle">
                    {treePermit?.name} Selection
                </Heading>
                {hasLocation && (
                    <ul className="tp-header-metadata-list">
                        {location.map((item, key) => {
                            return (
                                <li className="tp-header-metadata-list-item" key={key}>
                                    {item}
                                </li>
                            );
                        })}
                    </ul>
                )}
                <FormValidationAlert className="tp-errors" errors={errors} />
                {treePermit?.overview?.paragraphs && (
                    <div className="tp-header-description">
                        {treePermit?.overview?.paragraphs.map((item, index) => (
                            <DisplayHtmlContent key={index} html={item} />
                        ))}
                    </div>
                )}
            </Stack>
        </div>
    );
}

Header.propTypes = {
    errors: PropTypes.object.isRequired,
    parentLocation: PropTypes.any,
    treePermit: PropTypes.object,
};
